/**
 *
 * @constructor
 */
function ProcessPage() {
    /**
     *
     */
    ProcessPage.prototype.initialize = function (console, mesh, processInstance) {
        this.id = "process";
        this.console = console;
        this.mesh = mesh;
        this.processInstance = processInstance;

        return this;
    };

    /**
     *
     */
    ProcessPage.prototype.show = function () {
        var deferred = $.Deferred();

        this.console.consoleService.getProcessInstance(this.processInstance).done(function (processInstance) {
            this.processInstance = processInstance;

            console.log(">>>>>>>>>>>> Process Instance", this.processInstance);

            this.console.safeApply();
            deferred.resolve();
        }.bind(this)).fail(function (error) {
            console.error(error);
            deferred.reject(error);
        }.bind(this));

        deferred.resolve();

        return deferred.promise();
    };

    /**
     *
     */
    ProcessPage.prototype.leave = function () {
    };
}
